import React from "react";
import { getTimeSlots, timeValidator } from "../../../helpers/duration";
import InputField from "../../toolBox/InputField";
import { css } from "glamor";
import { colors, dropdownStyle } from "../../../helpers/styles";

// validator checken...

class HourPicker extends React.Component {
  handleBlur = (name) => {
    if (this.props.value === "24:00") {
      this.props.handleChange({
        target: { value: "00:00", name },
      });
      return;
    }
    const valTime = timeValidator(this.props.value);
    let value;
    if (valTime.error) {
      // need to correct this, make it better error
      value = "";
    } else {
      value = valTime;
    }
    this.props.handleChange({
      target: { value, name },
    });
  };

  render() {
    const { value, overnight, label, format12h } = this.props;
    const startSlots = getTimeSlots(format12h).map((t, i) => {
      return {
        id: i,
        name: t,
        action: (callback) => {
          this.props.handleChange({
            target: { value: t, name: this.props.startName },
          });
        },
      };
    });
    let ariaLabel;

    if (label === "Start time") {
      ariaLabel = "leave-details-start-time";
    } else if (label === "End time") {
      ariaLabel = "leave-details-end-time";
    }

    return (
      <div>
        <div {...css({ float: "left", position: "relative" })}>
          <InputField
            value={value}
            label={label}
            name={this.props.startName}
            changeInput={
              this.props.handleChange ? this.props.handleChange : () => {}
            }
            options={startSlots}
            handleBlur={this.handleBlur}
            noArrow={true}
            notDisabled={true}
            disabled={this.props.disabled}
            cursor="text"
            ariaLabel={ariaLabel}
            customDropdownStyle={{
              textAlign: "center",
            }}
          />
          {overnight && value === "00:00" && (
            <small
              {...css({
                position: "absolute",
                bottom: 8,
                right: 26,
                color: "rgba(0,0,0,0.87)",
                fontSize: 14,
                fontWeight: 300,
              })}
            >
              +1
            </small>
          )}
        </div>
      </div>
    );
  }
}

export default HourPicker;
